
import cookie from 'js-cookie';

// Types
import {
  USER_AUTH_REQUEST_START,
  USER_AUTH_REQUEST_FAIL,
  USER_AUTH_REQUEST_SUCCESS,
  SET_USER_AUTH_STATE,
  USER_AFFILIATE_DETAILS_REQUEST_START,
  USER_AFFILIATE_DETAILS_REQUEST_FAIL,
  USER_AFFILIATE_DETAILS_REQUEST_SUCCESS,
  UPDATE_USER_AFFILIATE_DETAILS_REQUEST_START,
  UPDATE_USER_AFFILIATE_DETAILS_REQUEST_FAIL,
  UPDATE_USER_AFFILIATE_DETAILS_REQUEST_SUCCESS,
  UPDATE_SETTINGS_STATUS_TO_INITIAL,
  API_REQUEST_FAIL_ERROR,
  UPDATE_LAUNCH_DARKLY_FLAG_CONFIG,
  SET_LOGIN_API_ERROR,
  SET_SUPER_USER_STATE
} from './types';
// Redux
import { getServicesErrorObj } from '../servicesDowntime/actions';
// API Wrapper
import {
  authenticate as auth,
  validateToken as validateTokenAction,
  clearSession,
  get,
  post,
  reSetUserAuth
} from './../session/actions';
// Utils
import TokenManager from '../../../core/utils/TokenManager/TokenManager';

const AFFILIATE_NUMBER_KEY: string = "affiliate-number";
const AFFILIATE_ID_KEY: string = "affiliate-id";
const AFFILIATE_EMAIL_ID: string = "affiliate-email";
const LOGGED_OUT: string = 'logged-out';
const COOKIE_PATH = '/';
const SUPER_USER_KEY: string = "super-user";

export const userAuthRequestStart = () => ({
  type: USER_AUTH_REQUEST_START
});

export const userAuthRequestFail = () => ({
  type: USER_AUTH_REQUEST_FAIL
});

export const userAuthRequestSuccess = (payload: any) => ({
  type: USER_AUTH_REQUEST_SUCCESS,
  payload
});

export const setUserAuthState = (payload: any) => ({
  type: SET_USER_AUTH_STATE,
  payload
});

export const getAffiliateDetailsRequestStart = () => ({
  type: USER_AFFILIATE_DETAILS_REQUEST_START
});

export const getAffiliateDetailsRequestFail = () => ({
  type: USER_AFFILIATE_DETAILS_REQUEST_FAIL
});

export const getAffiliateDetailsRequestSuccess = (payload: any) => ({
  type: USER_AFFILIATE_DETAILS_REQUEST_SUCCESS,
  payload
});

export const updateAffiliateDetailsRequestStart = () => ({
  type: UPDATE_USER_AFFILIATE_DETAILS_REQUEST_START
});

export const updateAffiliateDetailsRequestFail = (payload: Error) => ({
  type: UPDATE_USER_AFFILIATE_DETAILS_REQUEST_FAIL,
  payload
});

export const updateAffiliateDetailsRequestSuccess = () => ({
  type: UPDATE_USER_AFFILIATE_DETAILS_REQUEST_SUCCESS
});

export const updateSettingsStatusToInitial = () => ({
  type: UPDATE_SETTINGS_STATUS_TO_INITIAL
});

export const getApiFailErrorObj = (payload: any) => ({
  type: API_REQUEST_FAIL_ERROR,
  payload
});

export const setLaunchDarklyFlagObj = (payload: any) => ({
  type: UPDATE_LAUNCH_DARKLY_FLAG_CONFIG,
  payload
});

export const setLoginApiError = (payload: any) => ({
  type: SET_LOGIN_API_ERROR,
  payload
});

export const setSuperUserState = (payload: boolean) => ({
  type: SET_SUPER_USER_STATE,
  payload
});

export const authenticate = (credentials: any) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(userAuthRequestStart());

  dispatch(auth(credentials)).then((response: any) => {
    dispatch(userAuthRequestSuccess({}));
    resolve(response);
  }).catch((error: any) => {
    dispatch(userAuthRequestFail());
    dispatch(getServicesErrorObj(error));
    reject(error);
  });
});

export const validateToken = (token: string, email: string, affiliateNumber: string, accountSfId: string) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(userAuthRequestStart());

  dispatch(validateTokenAction(token, email, affiliateNumber, accountSfId)).then((response: any) => {
    dispatch(userAuthRequestSuccess({}));
    resolve(response);
  }).catch((error: any) => {
    dispatch(userAuthRequestFail());
    dispatch(getServicesErrorObj(error));
    reject(error);
  });
});

export const RemoveAllAuthCookie = () => {
  TokenManager.clearAllTokens();

  cookie.remove(AFFILIATE_NUMBER_KEY, { path: COOKIE_PATH });
  cookie.remove(AFFILIATE_ID_KEY, { path: COOKIE_PATH });
  cookie.remove(AFFILIATE_EMAIL_ID, { path: COOKIE_PATH });
  cookie.remove('Login.Successful', { path: COOKIE_PATH });
  sessionStorage.setItem(LOGGED_OUT, "true");
};

export const validate = (navigate) => (dispatch: Function) => new Promise((resolve, reject) => {

  const gotAffiliateId = Boolean(sessionStorage.getItem('affiliate-id'));
  const gotRefreshToken = TokenManager.hasValidRefreshToken();
  const gotSSOKey = Boolean(cookie.get("cdhCompanyWithSSO"));
  const isSuperUser = Boolean(sessionStorage.getItem(SUPER_USER_KEY));

  if (!gotAffiliateId || !gotRefreshToken) {
    RemoveAllAuthCookie();
    navigate("/login");

    dispatch(setUserAuthState(false));
  } else {
    dispatch(setUserAuthState(true));
    // Restore super user state from sessionStorage if present
    if (isSuperUser) {
      dispatch(setSuperUserState(true));
    }
    gotSSOKey && dispatch(getAffiliateDetails());
  }
  resolve('');
});

export const AFFILIATE_DETAILS_URL: Function = (affiliateId: string, emailId: string) => (
  `/v2/affiliate-portal/affiliates/${affiliateId}/details?email=${emailId}`
);

export const getAffiliateDetails = () => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(getAffiliateDetailsRequestStart());

  const AFFILIATE_ID: string | null = (sessionStorage.getItem('affiliate-id'));
  const AFFILIATE_EMAIL_ID: string | null = (sessionStorage.getItem('affiliate-email'));

  dispatch(get(AFFILIATE_DETAILS_URL(AFFILIATE_ID, AFFILIATE_EMAIL_ID))).then((response: any) => {
    dispatch(getAffiliateDetailsRequestSuccess(response.data));
    resolve(response);
  }).catch((error: any) => {
    dispatch(getAffiliateDetailsRequestFail());
    dispatch(getServicesErrorObj(error));
    if (error?.response?.data?.code === '2003') {
      dispatch(clearSession());
    }
    reject(error);
  });
});


const AFFILIATE_UPDATE_DETAILS_URL = `/v1/affiliate-portal/affiliates/updatedetails`;
export const updateAffiliateDetails = (
  contactDetails,
  address,
  allEmailPreferences,
  updatedClientTypes,
  updatedClientIndustries,
  updatedClientLanguages,
  updatedClientCountries,
  getAccountManagerEmails,
  optOutOfMarketing,
  getNotificationEmails,
  password,
  new_password
) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(updateAffiliateDetailsRequestStart());
  const AFFILIATE_ID: string | null = (sessionStorage.getItem('affiliate-id'));
  const passwordPayload = {
    "password": password,
    "new_password": new_password
  }
  const requestBody = {
    "SFAccount_ID": AFFILIATE_ID,
    "ClientData": {
      "client_Type": updatedClientTypes,
      "client_Languages": updatedClientLanguages,
      "client_Industry": updatedClientIndustries,
      "client_Based_Countries": updatedClientCountries,
      "account_Manager_Emails": getAccountManagerEmails
    },
    "affdetails": {
      "weekly_market_updates": allEmailPreferences.weekly_market_updates,
      "user_phone_no": contactDetails.mobileNumber,
      "user_country_isdcode": contactDetails.countryISDCode,
      "town": address.city,
      "promotions": allEmailPreferences.promotions,
      "product_news": allEmailPreferences.product_news,
      "post_code": address.postCode,
      "opt_me_out_of_marketing": optOutOfMarketing,
      "notification_required": getNotificationEmails,
      "newsletters": allEmailPreferences.newsletters,
      "news_flash": allEmailPreferences.news_flash,
      "research_development": allEmailPreferences?.research_development,
      "first_line": address.addressLineNo1,
      "daily_update": allEmailPreferences.daily_update,
      "county_state": address.state,
      "country": address.country,
      ...(new_password !== '' && { ...passwordPayload })
    }
  };

  /*
  * "client_Type" needs to not be present in the "ClientData" object if none of the checkboxes are selected.
  * Empty string for this causes the API to fail and give 400 Bad Request error
  */

  // updatedClientTypes.length > 0 && (requestBody["ClientData"]["client_Type"] = updatedClientTypes);

  dispatch(post(AFFILIATE_UPDATE_DETAILS_URL, requestBody)).then((response: any) => {
    dispatch(updateAffiliateDetailsRequestSuccess());
    dispatch(getAffiliateDetails());

  }).catch((error: Error) => {
    dispatch(updateAffiliateDetailsRequestFail(error));
    dispatch(getServicesErrorObj(error));
    reject(error);

  });
});

export const updateSettingsStatus = () =>
  (dispatch: Function) => {

    dispatch(updateSettingsStatusToInitial());
  };

export const updateLaunchDarklyFlagObject = (payload: any) =>
  (dispatch: Function) => {
    dispatch(setLaunchDarklyFlagObj(payload));
  };

export const resetUserDetailsStates = (payload: any) =>
  (dispatch: Function) => {
    dispatch(reSetUserAuth());
  };

export type AuthAction = {
  type: string,
  payload?: any
};

